/**
 * Represents a See All Plans Card component.
 */
export default class SeeAllPlansCard {
  constructor() {
    this.id = 'seeAllPlansCard';
  }

  /**
   * Sets the metadata URL for the current instance.
   *
   * @param {object} information - The information to be set as metadata.
   */
  setMetadata(information) {
    this.summaryCard = information;
    this.url = `${information.url}#HomesAndPlans`;
    this.totalPlans = information.totalPlans;
  }

  /**
   * Gets the HTML element with the specified ID.
   * @returns {HTMLElement} The HTML anchor element.
   */
  getElement() {
    return document.getElementById(this.id);
  }

  /**
   * Emits a custom event when a link is clicked on the summary card.
   */
  emitLinkClickEvent() {
    const linkClickEvent = new CustomEvent('summaryCardLinkClick', {
      detail: {
        summaryCard: this.summaryCard
      }
    });

    document.dispatchEvent(linkClickEvent);
  }

  /**
   * Binds events to the see all plans card.
   */
  bindEvents(element) {
    const callToActionLink = element.querySelector('[data-see-all-plans-card-link]');
    const callToActionCard = element.querySelector('[data-see-all-plans-card-cta]');
    callToActionCard?.addEventListener('click', this.emitLinkClickEvent.bind(this));
    callToActionLink?.addEventListener('click', this.emitLinkClickEvent.bind(this));
  }

  /**
   * Returns the HTML representation of the summary card.
   * @returns {string} The HTML string representing the summary card.
   */
  getHtml() {
    const classNames = [
      'nhs-c-card--summary',
      'nhs-c-carousel__element',
      'nhs-mq-card--summary-medium',
      'nhs-c-card--summary--see-all-plans',
      'nhs-u-background-color--teal-100'
    ];

    return `
            <div id="${this.id}" data-qa="map-card"
                data-summary-content
                class="${classNames.join(' ')}"
                data-card
            >      
              <div class="nhs-c-card--summary__wrapper nhs-u-min-height--full">          
                <a 
                  href="${this.url}"
                  target="_blank" 
                  data-see-all-plans-card-cta
                  class="nhs-c-card--summary__body nhs-o-layout--center nhs-u-items-center nhs-u-flex-column">
                    <svg class="nhs-u-color--teal-900"
                      xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none" viewBox="0 0 80 80">
                      <path fill="currentColor" d="M17 15h53l.257.007A5 5 0 0 1 75 20v47.385A3.615 3.615 0 0 1 71.385 71h-61.23a5.153 5.153 0 0 1-5.151-5H5V14a7 7 0 0 1 7-7h5zm0 47.797h-6.797a3.203 3.203 0 0 0-3.202 3.125A3.155 3.155 0 0 0 10.154 69h61.23c.893 0 1.616-.723 1.616-1.615V20a3 3 0 0 0-2.846-2.996L70 17H17zM61 22a4 4 0 0 1 4 4v33a4 4 0 0 1-4 4h-7V52.672c-5.578.116-10.188 4.176-11.148 9.506l-.149.822H28a4 4 0 0 1-3.995-3.794L24 59V26a4 4 0 0 1 4-4zM12 9a5 5 0 0 0-5 5v47.77a5.13 5.13 0 0 1 3.154-1.078H15V9zm16 15a2 2 0 0 0-2 2v20h12a1 1 0 0 1 0 2H26v11l.01.204A2 2 0 0 0 28 61h13.062c1.455-5.932 6.802-10.333 13.183-10.333.97 0 1.755.786 1.755 1.755V61h5l.204-.01A2 2 0 0 0 63 59V43H47V33a1 1 0 0 1 2 0v8h14V26a2 2 0 0 0-2-2z"/>
                    </svg>
                    <p class="nhs-c-card--summary__name nhs-u-color--teal-900 nhs-u-text--align-center nhs-u-width--full">
                      This community has ${this.totalPlans} floor plans.
                    </p>
                </a>
              </div>
              <a 
                href="${this.url}"
                target="_blank" 
                data-see-all-plans-card-link
                class="nhs-c-button--primary-white nhs-c-button--left-icon nhs-u-items-center nhs-c-button--small-32 nhs-u-width--full nhs-u-justify-content-center" data-qa="Map-Title">
                  See all floor plans
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                    <path fill="currentColor" d="M2.004 1.497a.5.5 0 0 0 0 1h10.793L1.65 13.643a.5.5 0 0 0 .707.707L13.504 3.204v10.793a.5.5 0 1 0 1 0v-11a1.5 1.5 0 0 0-1.347-1.493l-.153-.007z"/>
                  </svg>
              </a>
            </div>
        `;
    }
}